export class Filter {
    constructor (
        public Year: number,
        public Factory?: string[]
    ){
        
    }
}